

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState, Suspense, lazy } from "react";
import MainLayout from "./Layout/MainLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import PermissionGate from "./components/PermissionGate";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getMes, onMessageListener } from "./firebase";

// ================= PUBLIC =================
const Login = lazy(() => import("./default/Login/login"));
const AdminLogin = lazy(() => import("./default/Login/Adminlogin"));
// superAdminLogin
const SuperAdminLogin = lazy(() => import("./default/Login/superadminlogin"));

// const SalesLogin = lazy(() => import("./default/Login/Saleslogin"))

const Loginusers = lazy(() => import("./default/Login/userlogin"));

// import Loginusers from "./default/Login/userlogin";


const SignUp = lazy(() => import("./default/SignUp/signup"));
const ForgotPassword = lazy(() => import("./default/ForgotPassword/forgotpassword"));
const ResendPassword = lazy(() => import("./default/ResendPassword/resendpassword"));
const VerifyEmail = lazy(() => import("./default/ResendMail/resendmail"));
const VerifyOTP = lazy(() => import("./default/VerifyOTP/verifyOTP"));
const EnterMobileNumber = lazy(() => import("./default/EnterMobileNumber/mobilenumber"));
const Unmatched = lazy(() => import("./default/UnmatchedRoutes/unmatched"));
// const superAdminLogin =lazy(()=> import("./de"))

// ================= AFFILIATE =================
const Dashboard = lazy(() => import("./Affiliates/Dashboard/dashboard"));
const Analytics = lazy(() => import("./Affiliates/Analytics/analytics"));
const Forecast = lazy(() => import("./Affiliates/Forecast/forecast"));
const Badges = lazy(() => import("./Affiliates/Badges/badges"));
const Payments = lazy(() => import("./Affiliates/Payments/payments"));
const Profile = lazy(() => import("./Affiliates/Profile/profile"));
const Referrals = lazy(() => import("./Affiliates/Referrals/referrals"));
const ReferralLinks = lazy(() => import("./Affiliates/ReferralLinks/referrallinks"));
const Handleuserref = lazy(() => import("./Affiliates/ReferralLinks/userreferrallinks"));
const Unauthorized = lazy(() => import("./Affiliates/Unauthorized/unauthorized"));
const Acknowledgement = lazy(() => import("./Affiliates/Acknowledgement"));
const AffiliateChat = lazy(() => import("./Affiliates/Chat/chat"));
const AffiliateChatLanding = lazy(() => import("./Affiliates/Chat/chatLanding"));
const AffiliateEstimateRequests = lazy(() => import("./Affiliates/EstimateRequests/estimateRequests"));
const AffiliateAddEstimate = lazy(() => import("./Affiliates/EstimateRequests/addEstimate"));
const AffiliateMeetings = lazy(() => import("./Affiliates/meeting/meeting"));
const ClientOutreach = lazy(() => import("./Affiliates/Client Outreach/outreach"));

// Stripe
const KycSuccess = lazy(() => import("./Affiliates/Payments/KycSuccess"));
const KycRefresh = lazy(() => import("./Affiliates/Payments/KycRefresh"));

// ================= ADMIN =================
const Dashboards = lazy(() => import("./Admin/Dashboard/dashboard"));
const SalesDashboard = lazy(() => import("./Admin/SalesDashboard/SalesDashboard"));
const AdminReferrals = lazy(() => import("./Admin/Referrals/referrals"));
const Users = lazy(() => import("./Admin/Users/user"));
const AdminProtest = lazy(() => import("./Admin/Protest/protest"));
const AdminBadges = lazy(() => import("./Admin/Badges/badges"));
const AdminAnalytics = lazy(() => import("./Admin/Analytics/analytics"));
const Affiliates = lazy(() => import("./Admin/Affiliates/affiliates"));
const WithdrawRequest = lazy(() => import("./Admin/WithdrawRequest/withdraw"));
const Reports = lazy(() => import("./Admin/Reports/reports"));
const Activation = lazy(() => import("./Admin/Activation/activation"));
const ReferralRequest = lazy(() => import("./Admin/Referrals/referralRequest"));
const Handleversionpage = lazy(() => import("./Admin/Versions/versions"));
const Chat = lazy(() => import("./Admin/Chat/chat"));
const Notifications = lazy(() => import("./Admin/Notifications/notifications"));
const AuthenticateRoute = lazy(() => import("./components/AuthenticateRoute"));
const AdminAffiliatechat = lazy(() => import("./Admin/Chat/AdminAffiliatechat"));
const TrainingLibrary = lazy(() => import("./Admin/Traininglibrary/training"));
const AdminCoupons = lazy(() => import("./Admin/Coupons/coupon"));
const PushNotification = lazy(() => import("./Admin/Notifications/pushnotification"));
const Campaign = lazy(() => import("./Admin/Campaign/campaing"));
const Campaignsteplist = lazy(() => import("./Admin/Campaign/campaingLeadstep"));
const EstimateRequests = lazy(() => import("./Admin/EstimateRequests/estimateRequests"));
const AddEstimate = lazy(() => import("./Admin/EstimateRequests/addEstimate"));
const Properties = lazy(() => import("./Admin/Properties/properties"));
const Homestead = lazy(() => import("./Admin/Homestead/homested"));
const ReferralCodes = lazy(() => import("./Admin/Referralcodes/referralcode"));
const AdminGrafana = lazy(() => import("./Admin/Grafana/grafina"));
const RefundInvoiceList = lazy(() => import("./Admin/Refundinvoice/refundinvoicelist"));
const PartnersList = lazy(() => import("./Admin/Partners/PartnersList"));
const RecruiterMeetings = lazy(() => import("./Admin/RecriterMeeting/meeting"));
const PropertyReport = lazy(() => import("./Admin/PropertyReport/PropertyReportLanding"));

// ================= CMS MODULES =================
const CMSAllBlogs = lazy(() => import("./Admin/CMS/Blogs/AllBlogs"));
const CMSAddBlog = lazy(() => import("./Admin/CMS/Blogs/AddBlog"));
const CMSAllNews = lazy(() => import("./Admin/CMS/NewsUpdates/AllNews"));
const CMSAddNews = lazy(() => import("./Admin/CMS/NewsUpdates/AddNews"));
const CMSAllUpdates = lazy(() => import("./Admin/CMS/NewsUpdates/AllUpdates"));
const CMSAddUpdate = lazy(() => import("./Admin/CMS/NewsUpdates/AddUpdate"));
const CMSAllAuthors = lazy(() => import("./Admin/CMS/Authors/AllAuthors"));
const CMSAddAuthor = lazy(() => import("./Admin/CMS/Authors/AddAuthor"));
const CMSCategories = lazy(() => import("./Admin/CMS/Categories/Categories"));
const CMSTags = lazy(() => import("./Admin/CMS/Tags/Tags"));
const CMSMediaLibrary = lazy(() => import("./Admin/CMS/MediaLibrary/MediaLibrary"));
const CMSPages = lazy(() => import("./Admin/CMS/Pages/Pages"));
const CMSComments = lazy(() => import("./Admin/CMS/Comments/Comments"));
const CMSSubscribers = lazy(() => import("./Admin/CMS/Subscribers/Subscribers"));
const CMSSettings = lazy(() => import("./Admin/CMS/Settings/CMSSettings"));
const CMSFAQs = lazy(() => import("./Admin/CMS/FAQs/FAQs"));






// ================= SUPER ADMIN =================

const SuperAdminRoles = lazy(() => import("./SuperAdmin/RolesAndPermissions"));

const withPermission = (path, Component) => (
  <PermissionGate path={path}>
    <Component />
  </PermissionGate>
);

function App() {
  const { user } = useSelector((state) => state.auth);

  const [, setTokenFound] = useState(false);

  // ================= SAFARI CHECK =================
  const checkSafari = () => {
    return (
      /constructor/i.test(window.HTMLElement) ||
      (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(
        !window["safari"] ||
        (typeof safari !== "undefined" &&
          window["safari"].pushNotification)
      )
    );
  };

  // ================= FIREBASE TOKEN =================
  useEffect(() => {
    // Check if browser supports notifications
    if (!("Notification" in window)) {
      return;
    }

    if (checkSafari()) {
      return;
    }
    // Get user ID from Redux state
    const userId = user?.user?.id;

    // Request notification permission and get token
    Notification.requestPermission()
      .then((permission) => {
        if (permission === "granted") {
          if (userId) {
            getMes(setTokenFound, userId);
          } else {
            getMes(setTokenFound, null);
          }
        } else if (permission === "denied") {
          setTokenFound(false);
        } else {
          setTokenFound(false);
        }
      })
      .catch((err) => {
        setTokenFound(false);
      });
  }, [user]);

  // ================= FOREGROUND NOTIFICATIONS =================
  useEffect(() => {
    if (checkSafari()) {
      return;
    }
    if (!("Notification" in window)) {
      return;
    }

    onMessageListener()
      .then((payload) => {
        const title = payload?.notification?.title || "New Notification";
        const body = payload?.notification?.body || "";

        toast.success(title, {
          body: body,
        });
      })
      .catch((err) => {
      });
  }, []);

  return (
    <>
      <BrowserRouter>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            {/* ================= PUBLIC ROUTES ================= */}
            <Route path="/" element={<AuthenticateRoute />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/super-admin/login" element={<SuperAdminLogin />} />
            {/* Loginusers */}
            <Route path="/user/login" element={<Loginusers />} />

            {/* <Route path="/sales/login" element={<SalesLogin />} /> */}

            {/* SalesLogin */}
            {/* RolesLanding */}
            {/* <Route path="/roles-landing" element={<RolesLanding />} /> */}
            {/* EmailCheck */}
            {/* <Route path="/email-check" element={<EmailCheck />} /> */}

            {/* superAdminLogin */}

            <Route path="/SignUpScreen" element={<SignUp />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/resend-password" element={<ResendPassword />} />
            <Route path="/Verify_mail" element={<VerifyEmail />} />
            <Route path="/verify_otp" element={<VerifyOTP />} />
            <Route path="/enter-mobile" element={<EnterMobileNumber />} />

            {/* ================= PROTECTED ROUTES ================= */}
            <Route element={<MainLayout />}>
              {/* AFFILIATE */}
              <Route element={<ProtectedRoute allowedRoles={["affiliate"]} />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/forecast" element={<Forecast />} />
                <Route path="/badges" element={<Badges />} />
                <Route path="/referrals" element={<Referrals />} />
                <Route path="/referral-links" element={<ReferralLinks />} />
                <Route path="/user_referral" element={<Handleuserref />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/payments" element={<Payments />} />
                <Route path="/Kyc-success" element={<KycSuccess />} />
                <Route path="/Kyc-refresh" element={<KycRefresh />} />
                <Route path="/affiliate/chat/messages" element={<AffiliateChat />} />
                <Route path="/affiliate/chat" element={<AffiliateChatLanding />} />
                <Route path="/acknowledgement" element={<Acknowledgement />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/estimate-requests" element={<AffiliateEstimateRequests />} />
                <Route path="/estimate-requests/new" element={<AffiliateAddEstimate />} />
                <Route path="/affiliate-meetings" element={<AffiliateMeetings />} />
                <Route path="/client-outreach" element={<ClientOutreach />} />
                <Route path="/outreach" element={<Navigate to="/client-outreach" replace />} />

                {/* Acknowledgement */}
              </Route>

              {/* STAFF (admin, super_admin, custom roles — permission-gated per route) */}
              <Route element={<ProtectedRoute requireStaff />}>
                <Route path="/admin/dashboard" element={withPermission('/admin/dashboard', Dashboards)} />
                <Route path="/sales-dashboard" element={<Navigate to="/admin/sales-dashboard" replace />} />
                <Route path="/admin/sales-dashboard" element={withPermission('/admin/sales-dashboard', SalesDashboard)} />
                <Route path="/sales/sales-dashboard" element={withPermission('/sales/sales-dashboard', SalesDashboard)} />
                <Route path="/sales/dashboard" element={withPermission('/sales/dashboard', SalesDashboard)} />
                <Route path="/referral" element={withPermission('/referral', AdminReferrals)} />
                <Route path="/admin/referral-codes" element={withPermission('/admin/referral-codes', ReferralCodes)} />
                <Route path="/users" element={withPermission('/users', Users)} />
                <Route path="/admin-protest" element={withPermission('/admin-protest', AdminProtest)} />
                <Route path="/admin-badges" element={withPermission('/admin-badges', AdminBadges)} />
                <Route path="/referral-request" element={withPermission('/referral-request', ReferralRequest)} />
                <Route path="/admin-analytics" element={withPermission('/admin-analytics', AdminAnalytics)} />
                <Route path="/admin-grafana" element={<Navigate to="/admin-grafana/server" replace />} />
                <Route path="/admin-grafana/:dashboardType" element={withPermission('/admin-grafana', AdminGrafana)} />
                <Route path="/recruiters" element={withPermission('/recruiters', Affiliates)} />
                <Route path="/withdraw-request" element={withPermission('/withdraw-request', WithdrawRequest)} />
                <Route path="/admin/refund-invoices" element={withPermission('/admin/refund-invoices', RefundInvoiceList)} />
                <Route path="/reports" element={withPermission('/reports', Reports)} />
                <Route path="/activation" element={withPermission('/activation', Activation)} />
                <Route path="/versions" element={withPermission('/versions', Handleversionpage)} />
                <Route path="/admin/partners" element={withPermission('/admin/partners', PartnersList)} />
                <Route path="/admin-chat" element={withPermission('/admin-chat', Chat)} />
                <Route path="/admin/notifications" element={withPermission('/admin/notifications', Notifications)} />
                <Route path="/affiliate-chat" element={withPermission('/affiliate-chat', AdminAffiliatechat)} />
                <Route path="/training-library" element={withPermission('/training-library', TrainingLibrary)} />
                <Route path="/admin-coupons" element={withPermission('/admin-coupons', AdminCoupons)} />
                <Route path="/push-notification" element={withPermission('/push-notification', PushNotification)} />
                <Route path="/campaign" element={withPermission('/campaign', Campaign)} />
                <Route path="/campaign-leadstep" element={withPermission('/campaign-leadstep', Campaignsteplist)} />
                <Route path="/super-admin-roles" element={withPermission('/super-admin-roles', SuperAdminRoles)} />
                <Route path="/admin/estimate-requests" element={withPermission('/admin/estimate-requests', EstimateRequests)} />
                <Route path="/admin/estimate-requests/new" element={withPermission('/admin/estimate-requests/new', AddEstimate)} />
                <Route path="/admin/properties" element={withPermission('/admin/properties', Properties)} />
                <Route path="/admin/property-report" element={withPermission('/admin/property-report', PropertyReport)} />
                <Route path="/admin/homestead" element={withPermission('/admin/homestead', Homestead)} />
                <Route path="/admin/recruiter-meetings" element={withPermission('/admin/recruiter-meetings', RecruiterMeetings)} />
                <Route path="/sales/estimate-requests" element={withPermission('/sales/estimate-requests', EstimateRequests)} />
                <Route path="/sales/estimate-requests/new" element={withPermission('/sales/estimate-requests/new', AddEstimate)} />

                {/* CMS MODULE ROUTES */}
                <Route path="/admin/blogs" element={withPermission('/admin/blogs', CMSAllBlogs)} />
                <Route path="/admin/blogs/new" element={withPermission('/admin/blogs/new', CMSAddBlog)} />
                <Route path="/admin/blogs/edit/:id" element={withPermission('/admin/blogs/new', CMSAddBlog)} />
                <Route path="/admin/news" element={withPermission('/admin/news', CMSAllNews)} />
                <Route path="/admin/news/new" element={withPermission('/admin/news/new', CMSAddNews)} />
                <Route path="/admin/news/edit/:id" element={withPermission('/admin/news/new', CMSAddNews)} />
                <Route path="/admin/updates" element={withPermission('/admin/updates', CMSAllUpdates)} />
                <Route path="/admin/updates/new" element={withPermission('/admin/updates/new', CMSAddUpdate)} />
                <Route path="/admin/updates/edit/:id" element={withPermission('/admin/updates/new', CMSAddUpdate)} />
                <Route path="/admin/authors" element={withPermission('/admin/authors', CMSAllAuthors)} />
                <Route path="/admin/authors/new" element={withPermission('/admin/authors/new', CMSAddAuthor)} />
                <Route path="/admin/authors/edit/:id" element={withPermission('/admin/authors/new', CMSAddAuthor)} />
                <Route path="/admin/categories" element={withPermission('/admin/categories', CMSCategories)} />
                <Route path="/admin/tags" element={withPermission('/admin/tags', CMSTags)} />
                <Route path="/admin/media-library" element={withPermission('/admin/media-library', CMSMediaLibrary)} />
                <Route path="/admin/pages" element={withPermission('/admin/pages', CMSPages)} />
                <Route path="/admin/comments" element={withPermission('/admin/comments', CMSComments)} />
                <Route path="/admin/subscribers" element={withPermission('/admin/subscribers', CMSSubscribers)} />
                <Route path="/admin/cms-settings" element={withPermission('/admin/cms-settings', CMSSettings)} />
                <Route path="/admin/faqs" element={withPermission('/admin/faqs', CMSFAQs)} />
              </Route>

              <Route path="/unauthorized" element={<Unauthorized />} />
            </Route>

            {/* Catch-all route for 404 */}
            <Route path="*" element={<Unmatched />} />
          </Routes>
        </Suspense>
      </BrowserRouter>

      <ToastContainer
        style={{ zIndex: 9999999 }}
        position="top-right"
        autoClose={3000}
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;





